<nav>
  <button
    mat-button
    color="accent"
    *ngIf="showBack"
    [disabled]="backDisabled"
    [routerLink]="backRouterLink"
    (click)="onBack()"
    data-testid="wizard-nav-back-button"
  >
    <mat-icon
      svgIcon="arrow-left"
      data-testid="wizard-nav-back-button-icon"
    ></mat-icon>
    {{ backLabel }}
  </button>
</nav>

<nav>
  <mat-spinner diameter="32" *ngIf="showSpinner"></mat-spinner>
  <button
    mat-flat-button
    color="accent"
    *ngIf="showNext"
    [disabled]="nextDisabled"
    [routerLink]="nextRouterLink"
    (click)="onNext()"
    data-testid="wizard-nav-next-button"
  >
    {{ nextLabel }}
  </button>
</nav>

<ng-template #confirmDialog>
  <div class="service-dialog">
    <h2>Do you want to save your progress?</h2>
    <mat-icon-button
      mat-icon-button
      cdkFocusInitial
      class="close"
      aria-label="Close dialog"
      color="accent"
      [mat-dialog-close]=""
    >
      <mat-icon>close</mat-icon>
    </mat-icon-button>
    <div class="remove-modal-button-wrapper">
      <button mat-stroked-button [mat-dialog-close]="">No</button>
      <button mat-flat-button color="accent" class="remove-button">Yes</button>
    </div>
  </div>
</ng-template>
